import React from "react";
import { Link } from "react-router-dom";
import bgheader3png from "../../../assets/images/bg-header-3.png";
import blog3png from "../../../assets/images/blog-3.png";
import avatar1png from "../../../assets/images/avatar-1.png";
import blog1smpng from "../../../assets/images/blog-1-sm.png";

function SinglePost(props) {
  return (
    <>
      <header className="dx-header dx-box-5">
        <div className="bg-image bg-image-parallax">
          <img src={bgheader3png} className="jarallax-img" alt="" />
          <div style={{ backgroundColor: "rgba(27, 27, 27, 0.8)" }}></div>
        </div>
        <div className="container mnb-8">
          <div className="row justify-content-center">
            <div className="col-xl-7">
              <h1 className="h4 mb-10 text-white text-center">
                The Big Thing in Design
              </h1>

              <ul className="dx-breadcrumbs text-center">
                <li>
                  <Link to="/index">Home</Link>
                </li>
                <li>
                  <Link to="/blog">Blog</Link>
                </li>
                <li>The Big Thing in Design</li>
              </ul>
            </div>
          </div>
        </div>
      </header>
      <div className="dx-box-1 pb-100 bg-grey-6">
        <div className="container">
          <div className="row vertical-gap md-gap">
            <div className="col-lg-8">
              <div className="dx-blog-post dx-box dx-box-decorated">
                <div className="dx-gallery pt-10 pr-10 pl-10">
                  <Link
                    to="/single-post"
                    data-fancybox="images"
                    className="dx-gallery-item"
                  >
                    <span className="dx-gallery-item-overlay">
                      <span className="icon pe-7s-exapnd2"></span>
                    </span>
                    <img src={blog3png} className="dx-img" alt="" />
                  </Link>
                </div>
                <div className="dx-blog-post-box">
                  <h1 className="h3 dx-blog-post-title">
                    <Link to="/single-post">The Big Thing in Design</Link>
                  </h1>
                  <ul className="dx-blog-post-info">
                    <li>Date: 25 Sep 2018</li>
                    <li>Views: 124</li>
                    <li>
                      Category:{" "}
                      <ul className="dx-blog-post-categories">
                        <li>
                          <Link to="/#">News</Link>
                        </li>
                      </ul>
                    </li>
                    <li>
                      Author: <Link to="/#">John</Link>
                    </li>
                  </ul>
                  <p className="mnb-2">
                    Hath without winged from creature won't the seas midst
                    without every gathering place is beast and, unto, and
                    darkness of rule don't third male moving winged is two have
                    deep abundantly wherein. There god fruitful Make appear.
                    Night made Isn't.
                  </p>
                </div>
                <div className="dx-blog-post-box">
                  <blockquote className="dx-blockquote mnt-10 mb-0">
                    {" "}
                    Fruit male face green be also darkness meat sixth shall all
                    Fish. Hath creature. Sea all creepeth first which creepeth
                    without gathered us deep.{" "}
                  </blockquote>
                </div>
                <div className="dx-blog-post-box">
                  <h2 className="h5 mnt-10">Abundantly, bring wherein?</h2>
                  <p>
                    Fruit male face green be also darkness meat sixth shall all
                    Fish. Hath creature. Sea all creepeth first which creepeth
                    without gathered us deep.
                  </p>
                  <div className="dx-gallery">
                    <div className="row vertical-gap">
                      <div className="col-6">
                        <Link
                          to="/single-post"
                          data-fancybox="images"
                          className="dx-gallery-item"
                        >
                          <span className="dx-gallery-item-overlay dx-gallery-item-overlay-md">
                            <span className="icon pe-7s-exapnd2"></span>
                          </span>
                          <img src={blog3png} className="dx-img" alt="" />
                        </Link>
                      </div>
                      <div className="col-6">
                        <Link
                          to="/single-post"
                          data-fancybox="images"
                          className="dx-gallery-item"
                        >
                          <span className="dx-gallery-item-overlay dx-gallery-item-overlay-md">
                            <span className="icon pe-7s-exapnd2"></span>
                          </span>
                          <img src={blog3png} className="dx-img" alt="" />
                        </Link>
                      </div>
                      <div className="col-6">
                        <Link
                          to="/single-post"
                          data-fancybox="images"
                          className="dx-gallery-item"
                        >
                          <span className="dx-gallery-item-overlay dx-gallery-item-overlay-md">
                            <span className="icon pe-7s-exapnd2"></span>
                          </span>
                          <img src={blog3png} className="dx-img" alt="" />
                        </Link>
                      </div>
                      <div className="col-6">
                        <Link
                          to="/single-post"
                          data-fancybox="images"
                          className="dx-gallery-item"
                        >
                          <span className="dx-gallery-item-overlay dx-gallery-item-overlay-md">
                            <span className="icon pe-7s-exapnd2"></span>
                          </span>
                          <img src={blog3png} className="dx-img" alt="" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="dx-blog-post-box">
                  <h2 className="h5 mnt-4">Theme Options</h2>
                  <p>
                    Great saying. Third is meat green isn't grass sixth
                    creeping:
                  </p>
                  <ul className="dx-blog-post-list mnb-7">
                    <li>Theme Style</li>
                    <li>Fonts</li>
                    <li>Navigation</li>
                    <li>Single Page</li>
                    <li>Single Post</li>
                    <li>Single Match</li>
                    <li>Posts Archive</li>
                    <li>WooCommerce</li>
                    <li>bbPress</li>
                    <li>BuddyPress</li>
                    <li>Search Page</li>
                    <li>404</li>
                    <li>Footer</li>
                    <li>Twitter</li>
                    <li>Instagram</li>
                    <li>Maintenance</li>
                  </ul>
                </div>
                <div className="dx-separator"></div>
                <div className="dx-blog-post-box pt-30 pb-30">
                  <ul className="dx-blog-post-tags mnt-6 mnb-1 db">
                    <li className="dx-blog-post-tags-title">Tags:</li>
                    <li>
                      <Link to="/#">Branding</Link>
                    </li>
                    <li>
                      <Link to="/#">Design</Link>
                    </li>
                    <li>
                      <Link to="/#">People</Link>
                    </li>
                  </ul>
                  <ul className="dx-social-links dx-social-links-style-2 mt-15">
                    <li>
                      <Link to="/#" className="dx-social-twitter">
                        <span className="icon fab fa-twitter"></span> Twitter
                      </Link>
                    </li>
                    <li>
                      <Link to="/#" className="dx-social-facebook">
                        <span className="icon fab fa-facebook"></span> Facebook
                      </Link>
                    </li>
                    <li>
                      <Link to="/#" className="dx-social-google">
                        <span className="icon fab fa-google"></span> Google
                      </Link>
                    </li>
                    <li>
                      <Link to="/#" className="dx-social-pinterest">
                        <span className="icon fab fa-pinterest"></span>{" "}
                        Pinterest
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="dx-box mt-55">
                <h2 className="h4 mb-45">Comments:</h2>
                <div className="dx-comment">
                  <div>
                    <div className="dx-comment-img">
                      <img src={avatar1png} alt="" />
                    </div>
                    <div className="dx-comment-cont">
                      <Link to="/#" className="dx-comment-name">
                        John Leonard
                      </Link>
                      <Link to="/#" className="dx-comment-reply">
                        Reply
                      </Link>
                      <div className="dx-comment-text">
                        <p className="mb-0">
                          Nullam ac dui et purus malesuada gravida id fermentum
                          orci. In eu ipsum quis urna hendrerit condimentum
                          vitae a mauris. In congue turpis purus, vitae tempus
                          ante id. Donec orci arcu, sagittis ut finibus vitae.
                        </p>
                      </div>
                      <div className="dx-comment-date">12 Feb 2018 7:40 pm</div>
                    </div>
                  </div>
                  <div className="dx-comment">
                    <div>
                      <div className="dx-comment-img">
                        <img src={avatar1png} alt="" />
                      </div>
                      <div className="dx-comment-cont">
                        <Link to="/#" className="dx-comment-name">
                          Mercy Shields
                        </Link>
                        <Link to="/#" className="dx-comment-reply">
                          Reply
                        </Link>
                        <div className="dx-comment-text">
                          <p className="mb-0">
                            In at nunc sodales lorem blandit egestas.
                            Suspendisse molestie fringilla purus, eget sagittis
                            nunc ornare sit amet. Praesent vitae ligula eu massa
                            rutrum hendrerit non facilisis nulla interdum ut.
                          </p>
                        </div>
                        <div className="dx-comment-date">
                          14 Feb 2018 8:29 am
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="dx-comment">
                  <div>
                    <div className="dx-comment-img">
                      <img src={avatar1png} alt="" />
                    </div>
                    <div className="dx-comment-cont">
                      <Link to="/#" className="dx-comment-name">
                        Maria Anthony
                      </Link>
                      <Link to="/#" className="dx-comment-reply">
                        Reply
                      </Link>
                      <div className="dx-comment-text">
                        <p className="mb-0">
                          Donec libero sapien, dapibus id blandit sit amet,
                          iaculis sed ligula. Morbi cursus maximus elementum.
                          Phasellus viverra lacinia sapien sagittis tristique.
                        </p>
                      </div>
                      <div className="dx-comment-date">18 Feb 2018 7:13 pm</div>
                    </div>
                  </div>
                </div>
                <form action="#" className="dx-form mt-50">
                  <div className="row vertical-gap">
                    <div className="col-md-6">
                      <input
                        className="form-control form-control-style-3"
                        type="text"
                        placeholder="Name"
                      />
                    </div>
                    <div className="col-md-6">
                      <input
                        className="form-control form-control-style-3"
                        type="text"
                        placeholder="Name"
                      />
                    </div>
                    <div className="col-12">
                      <textarea
                        className="form-control form-control-style-3"
                        name="name"
                        rows="8"
                        cols="80"
                        placeholder="Comment..."
                      ></textarea>
                    </div>
                    <div className="col-12">
                      <button
                        type="button"
                        name="button"
                        className="dx-btn dx-btn-lg"
                      >
                        Post a comment
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="dx-sticky dx-sidebar">
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title">
                    {" "}
                    Subscribe to Newsletter{" "}
                  </div>
                  <div className="dx-widget-subscribe">
                    <div className="dx-widget-text">
                      <p>
                        Join the newsletter to receive news, updates, new
                        products and freebies in your inbox.
                      </p>
                    </div>
                    <form action="#" className="dx-form dx-form-group-inputs">
                      <input
                        type="email"
                        name=""
                        value=""
                        aria-describedby="emailHelp"
                        className="form-control form-control-style-2"
                        placeholder="Your Email Address"
                      />
                      <button className="dx-btn dx-btn-lg dx-btn-icon">
                        <span className="icon fas fa-paper-plane"></span>
                      </button>
                    </form>
                  </div>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <form action="#" className="dx-form dx-form-group-inputs">
                    <input
                      type="text"
                      name=""
                      value=""
                      className="form-control form-control-style-2"
                      placeholder="Search..."
                    />
                    <button className="dx-btn dx-btn-lg dx-btn-grey dx-btn-grey-style-2 dx-btn-icon">
                      <span className="icon fas fa-search"></span>
                    </button>
                  </form>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title">Categories</div>
                  <ul className="dx-widget-categories">
                    <li>
                      <Link to="/single-article-category">
                        <span className="icon pe-7s-angle-right"></span>
                        <span className="dx-widget-categories-category">
                          Design & Coding
                        </span>
                        <span className="dx-widget-categories-badge">(12)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/single-article-category">
                        <span className="icon pe-7s-angle-right"></span>
                        <span className="dx-widget-categories-category">
                          News
                        </span>
                        <span className="dx-widget-categories-badge">(8)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/single-article-category">
                        <span className="icon pe-7s-angle-right"></span>
                        <span className="dx-widget-categories-category">
                          Inspirations
                        </span>
                        <span className="dx-widget-categories-badge">(2)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/single-article-category">
                        <span className="icon pe-7s-angle-right"></span>
                        <span className="dx-widget-categories-category">
                          Theme Reviews
                        </span>
                        <span className="dx-widget-categories-badge">(14)</span>
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title"> Latest Posts </div>
                  <Link to="/single-post" className="dx-widget-post">
                    <span className="dx-widget-post-img">
                      <img src={blog1smpng} alt="" />
                    </span>
                    <span className="dx-widget-post-text">
                      <span className="dx-widget-post-title">
                        The Big Thing in Design
                      </span>
                      <span className="dx-widget-post-date">25 Sep 2018</span>
                    </span>
                  </Link>
                  <Link to="/single-post" className="dx-widget-post">
                    <span className="dx-widget-post-img">
                      <img src={blog1smpng} alt="" />
                    </span>
                    <span className="dx-widget-post-text">
                      <span className="dx-widget-post-title">
                        Will Coding Ever Rule the World?
                      </span>
                      <span className="dx-widget-post-date">24 Sep 2018</span>
                    </span>
                  </Link>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title"> Tags Widget </div>
                  <ul className="dx-widget-tags">
                    <li>
                      <Link to="/#">Art</Link>
                    </li>
                    <li>
                      <Link to="/#">People</Link>
                    </li>
                    <li>
                      <Link to="/#">Branding</Link>
                    </li>
                    <li>
                      <Link to="/#">City</Link>
                    </li>
                    <li>
                      <Link to="/#">Design</Link>
                    </li>
                    <li>
                      <Link to="/#">Nature</Link>
                    </li>
                    <li>
                      <Link to="/#">Lifestyle</Link>
                    </li>
                    <li>
                      <Link to="/#">Photography</Link>
                    </li>
                  </ul>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title"> Our Twitter </div>
                  <div className="dx-twitter-list" data-twitter-count="3">
                    Failed to fetch data
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SinglePost;
